import React from 'react';
import { Button, Modal, Row, Typography } from 'components';
import { useMainSupplierRemoveModal } from 'feature/brandTabs/pricingAndSuppliers/supplierGrid/mainSupplierRemoveModal/useMainSupplierRemoveModal';
import { RemoveIconBig } from 'components/common/icons';
import { Col } from 'antd';

const { Title, Text } = Typography;

interface IMainSupplierRemoveModal {
  modalState: boolean;
  onModalStateChange: () => void;
}

export const MainSupplierRemoveModal = React.memo((props: IMainSupplierRemoveModal) => {
  const { modalState, onModalStateChange } = props;
  const { handleCancel, handleSubmit, contextHolder, isLoading } = useMainSupplierRemoveModal({ onModalStateChange });
  return (
    <>
      {contextHolder}
      <Modal
        open={modalState}
        onOk={handleSubmit}
        onCancel={handleCancel}
        closable={false}
        width={360}
        centered
        footer={() => (
          <Row wrap={false} className={'gap-8'} style={{ marginTop: '24px' }}>
            <Button block size={'large'} onClick={handleCancel}>
              Cancel
            </Button>
            <Button loading={isLoading} block size={'large'} type="primary" onClick={handleSubmit}>
              Remove
            </Button>
          </Row>
        )}
      >
        <Row align={'middle'} gutter={[0, 12]} justify={'center'}>
          <RemoveIconBig />
          <Col span={24}>
            <Title style={{ color: '#222530', textAlign: 'center', margin: 0, padding: 0 }} level={3}>
              Remove Main Supplier
            </Title>
          </Col>
          <Text className={'center'}>Are you sure you want to remove main supplier?</Text>
        </Row>
      </Modal>
    </>
  );
});
